import { render, staticRenderFns } from "./TabelaRecursosProprios.vue?vue&type=template&id=323ccaa1"
import script from "./TabelaRecursosProprios.vue?vue&type=script&lang=js"
export * from "./TabelaRecursosProprios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports